import { createTheme } from '@mui/material/styles';
import Abril from '../../fonts/Abril_Fatface/AbrilFatface-Regular.ttf'

/* ------------------------------------------------------------------
   Design tokens — mirrored in index.css as CSS custom properties.
   Dark, high-contrast palette built around the ONE Championship
   black + red identity, with a championship-gold highlight.
------------------------------------------------------------------ */
export const tokens = {
  ink: '#08090A',
  surface: '#0F1013',
  surface2: '#16181D',
  line: 'rgba(255, 255, 255, 0.09)',
  lineStrong: 'rgba(255, 255, 255, 0.18)',
  red: '#E01A22',
  redDeep: '#A3101A',
  gold: '#E8C36B',
  white: '#F6F6F5',
  muted: '#9B9BA3',
  dim: '#6A6A72',
  display: "'American Captain', 'Barlow Condensed', Impact, sans-serif",
  heading: "'Barlow Condensed', 'Oswald', sans-serif",
  body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  ease: 'cubic-bezier(0.16, 1, 0.3, 1)',
};

/* The theme keeps its original breakpoints (md: 1300, with lg: 1200 below it)
   because existing pages depend on them. Layout that should switch at a normal
   laptop width uses this query instead: below it, sections stack and the nav
   collapses to the menu. */
export const WIDE_LAYOUT_QUERY = '(min-width: 1151px)';

const dashboardTheme = createTheme({
  breakpoints: {
    values: {
      xs: 200,
      sm: 600,
      md: 1300,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
          @font-face {
            font-family: 'Abril';
            font-style: normal;
            font-display: swap;
            font-weight: 400;
            src: local('Abril'), local('Abril-regular'), url(${Abril}) format('ttf');
            unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
          }
          body { background-color: ${tokens.ink}; }
        `,
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: tokens.heading,
          fontSize: '1rem',
          fontWeight: 600,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          borderRadius: 2,
          boxShadow: 'none',
          ':hover': { boxShadow: 'none' },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
  },
  palette: {
    mode: 'dark',
    customColors: {
      // Brand
      red: tokens.red,
      redDeep: tokens.redDeep,
      gold: tokens.gold,
      // Surfaces
      ink: tokens.ink,
      surface: tokens.surface,
      surface2: tokens.surface2,
      line: tokens.line,
      lineStrong: tokens.lineStrong,
      // Text
      white: tokens.white,
      muted: tokens.muted,
      dim: tokens.dim,
      // Kept for backwards compatibility with older sections
      blue: '#005792',
    },
    primary: {
      main: tokens.red,
      light: '#FF3B43',
      dark: tokens.redDeep,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: tokens.white,
      light: tokens.muted,
      dark: '#C9C9CC',
      contrastText: tokens.ink,
    },
    background: {
      default: tokens.ink,
      paper: tokens.surface,
    },
    text: {
      primary: tokens.white,
      secondary: tokens.muted,
    },
    divider: tokens.line,
  },
  typography: {
    fontFamily: tokens.body,
    button: { textTransform: 'uppercase' },
  },
});

export default dashboardTheme
